<script setup lang="ts">
import PasswordChangeFormCard from "@/app/components/settings/PasswordChangeFormCard.vue";
import { useClientProfile } from "@/app/composables/useClientProfile";

const { changePassword } = useClientProfile();
</script>

<template>
    <PasswordChangeFormCard :change-password="changePassword" />
</template>
